import { Action } from "@ngrx/store";
import { IManualItem } from "../../models/manual-item";

export const RESET_STATE = "[manual] ResetState";
export const ADD = "[manual] Add";
export const REPLACE = "[manual] Replace";
export const REPLACE_MULTIPLE = "[manual] Replace multiple";
export const UPDATE = "[manual] Update";
export const DELETE = "[manual] Delete";

/**
 * Every action is comprised of at least a type and an optional
 * payload. Expressing actions as classes enables powerful
 * type checking in reducer functions.
 *
 * See Discriminated Unions: https://www.typescriptlang.org/docs/handbook/advanced-types.html#discriminated-unions
 */
export class ResetStateAction implements Action {
  readonly type = RESET_STATE;
  constructor(public payload?: IManualItem) {}
}

export class AddAction implements Action {
  readonly type = ADD;
  constructor(public payload: IManualItem) {}
}

export class ReplaceAction implements Action {
  readonly type = REPLACE;
  constructor(public payload: IManualItem) {}
}

export class ReplaceMultipleAction implements Action {
  readonly type = REPLACE_MULTIPLE;
  constructor(public payload: IManualItem[]) {}
}

export class UpdateAction implements Action {
  readonly type = UPDATE;
  constructor(public payload: IManualItem) {}
}

export class DeleteAction implements Action {
  readonly type = DELETE;
  constructor(public payload: { id: string }) {}
}

/**
 * Export a type alias of all actions in this action group
 * so that reducers can easily compose action types
 */
export type Actions =
  | ResetStateAction
  | AddAction
  | ReplaceAction
  | ReplaceMultipleAction
  | UpdateAction
  | DeleteAction;



// WEBPACK FOOTER //
// ./src/app/store/actions/manual-item.actions.ts